import Model from './Model';

export default class Vip extends Model {
  resource() {
    return 'vips';
  }
}
